import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import { QrcodeIndexPathName, QrcodeIndexPath } from '@/common/index';
import MailLayout from '@/views/mail/MailLayout.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: QrcodeIndexPath,
    name: QrcodeIndexPathName,
    component: () => import(/* webpackChunkName: "qrcode" */ '@/views/QrcodeConfirmedIndex.vue')
  },
  {
    path: '/',
    name: 'Home',
    redirect: Vue.prototype.$isMobile() ? '/my-info' : undefined,
    component: () =>
      Vue.prototype.$isMobile()
        ? import(/* webpackChunkName: "mobile" */ '@/viewM/employeeM/MyInfoM.vue')
        : import(/* webpackChunkName: "desktop" */ '@/views/Home.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () =>
      Vue.prototype.$isMobile()
        ? import(/* webpackChunkName: "mobile" */ '@/viewM/LoginM.vue')
        : import(/* webpackChunkName: "desktop" */ '@/views/LoginNew.vue')
  },
  {
    path: '/sites',
    name: 'SiteAdmin',
    component: () =>
      Vue.prototype.$isMobile()
        ? import(/* webpackChunkName: "mobile" */ '@/viewM/sites-adminM/SiteAdminM.vue')
        : import(/* webpackChunkName: "desktop" */ '@/views/sites-admin/SiteAdmin.vue'),
    children: [
      {
        path: '/sites/:id',
        name: 'SiteDetail',
        component: () =>
          Vue.prototype.$isMobile()
            ? import(/* webpackChunkName: "mobile" */ '@/viewM/sites-adminM/SiteDetailM.vue')
            : import(/* webpackChunkName: "desktop" */ '@/views/sites-admin/SiteAdmin.vue')
      }
    ]
  },
  {
    path: '/employee-admin',
    name: 'EmployeeAdmin',
    component: () => import(/* webpackChunkName: "desktop" */ '@/views/employee-admin/EmployeeAdmin.vue')
  },

  {
    path: '/audit-log',
    name: 'AuditLogs',
    component: () => import(/* webpackChunkName: "desktop" */ '@/views/audit-log/AuditLogs.vue')
  },
  {
    path: '/my-info',
    name: 'MyInfo',
    component: () =>
      Vue.prototype.$isMobile()
        ? import(/* webpackChunkName: "mobile" */ '@/viewM/employeeM/MyInfoM.vue')
        : import(/* webpackChunkName: "desktop" */ '@/views/employee/MyInfo.vue')
  },
  {
    // 修改密码
    path: '/my-settings',
    name: 'MySettings',
    component: () =>
      Vue.prototype.$isMobile()
        ? import(/* webpackChunkName: "mobile" */ '@/viewM/employeeM/MySettingsM.vue')
        : import(/* webpackChunkName: "desktop" */ '@/views/employee/MySettings.vue')
  },
  {
    path: '/mail',
    name: 'MailLayout',
    component: MailLayout,
    children: [
      {
        path: 'app-password',
        name: 'AppPassword',
        component: () => import(/* webpackChunkName: "mail" */ '@/views/mail/MailAppPasswordPage.vue')
      },
      {
        path: 'undo',
        name: 'EmailUndo',
        component: () => import(/* webpackChunkName: "mail" */ '@/views/mail/MailUndoPage.vue')
      },
      {
        path: 'attachments',
        name: 'MailAttachments',
        component: () => import(/* webpackChunkName: "mail" */ '@/views/mail/attachment/Attachments.vue')
      },
      {
        path: 'mailing-lists',
        name: 'MailingLists',
        component: () => import(/* webpackChunkName: "mail" */ '@/views/mail/mailing-list/MailingListsPage.vue')
      },
      {
        path: 'search',
        name: 'EmailSearch',
        component: () => import(/* webpackChunkName: "mail" */ '@/views/mail/mailing-list/EmailSearchPage.vue')
      },
      {
        path: 'import',
        name: 'ImportMails',
        meta: {
          title: '邮件轨迹测试工具'
        },
        component: () => import(/* webpackChunkName: "mail" */ '@/views/mail/import/ImportMailsPage.vue')
      }
    ]
  },
  {
    path: '/email-settings',
    redirect: '/mail/app-password',
    name: 'EmailSettingsOld'
  },
  {
    path: '/mail-attachments',
    redirect: '/mail/attachments',
    name: 'MailAttachmentsOld'
  },
  {
    path: '/subscribe',
    name: 'Subscribe',
    component: () => import(/* webpackChunkName: "desktop" */ '@/views/subscribe/Subscribe.vue')
  },
  {
    path: '/attachment-shard-view',
    name: 'AttachmentShardView',
    meta: {
      hideMenu: true,
      loginRequired: false
    },
    component: () => import(/* webpackChunkName: "attachment" */ '@/views/mail/attachment/AttachmentShardView.vue')
  }
];

if (Vue.prototype.$isMobile()) {
  routes.push({
    // 登陆成功情况下忘记密码
    path: '/forgo-password-login',
    name: 'ForgoPasswordLogin',
    component: () => import(/* webpackChunkName: "mobile" */ '@/viewM/employeeM/ForgoPassword.vue')
  });
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

// 设置浏览器 tab 标题, 未配置 meta.title 的路由保持 index.html 的默认标题
router.afterEach(to => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
});

export default router;
